import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var FirebaseNodeSanitizer = /*#__PURE__*/function () {
  function FirebaseNodeSanitizer() {
    _classCallCheck(this, FirebaseNodeSanitizer);
  }

  _createClass(FirebaseNodeSanitizer, [{
    key: "encodeKey",
    value: function encodeKey(s) {
      return s.replace(/\_/g, "__").replace(/\./g, "_p").replace(/\$/g, "_d").replace(/#/g, "_h");
    }
  }, {
    key: "decodeKey",
    value: function decodeKey(s) {
      var i = 0;
      var ni;
      var res = "";

      while ((ni = s.indexOf("_", i)) != -1) {
        res += s.substring(i, ni);

        if (ni + 1 < s.length) {
          var nc = s.charAt(ni + 1);

          if (nc == "_") {
            res += "_";
          } else if (nc == "p") {
            res += ".";
          } else if (nc == "d") {
            res += "$";
          } else if (nc == "h") {
            res += "#";
          } else {}

          i = ni + 2;
        } else {
          break;
        }
      }

      res += s.substring(i);
      return res;
    }
  }]);

  return FirebaseNodeSanitizer;
}();

var FirebaseNodeSanitizer_default = new FirebaseNodeSanitizer();
export { FirebaseNodeSanitizer_default as default };